export default class ImageUtils {
    static notHaveValidImageType(type) {
        type = type.toUpperCase();
        const types = ['IMAGE/JPG', 'IMAGE/JPEG', 'IMAGE/BMP', 'IMAGE/GIF', 'IMAGE/ANIMATED GIF', 'IMAGE/WEBP', 'IMAGE/WBMP', 'IMAGE/PNG'];
        return !types.includes(type);
    }
    static notHaveValidName(name) {
        name = name.toUpperCase();
        const names = ['.JPG', '.JPEG', '.BMP', '.GIF', '.ANIMATED GIF', '.WEBP', '.WBMP', '.PNG'];
        for (let index = 0; index < names.length; index++) {
            const element = names[index];
            if (name.includes(element)) {
                return false;
            }
        }
        return true;
    }

    static notValidImageFormat(selectedIamge) {
        let typeResult = undefined;
        let nameResult = undefined;
        if (selectedIamge.type) {
            typeResult = this.notHaveValidImageType(selectedIamge.type);
        }
        if (selectedIamge.name) {
            nameResult = this.notHaveValidName(selectedIamge.name);
        }
        return typeResult || nameResult;
    }
}
